module.exports = __webpack_public_path__ + "static/media/Credits-19.08bd0f2c.pdf";